import axios from "axios";

const oidcSignIn = async (searchParamString) => {
  const signIn_api = "/login/gcl_oidc/callback";
  const params = new URLSearchParams(searchParamString);
  try {

    const result = await axios({
      method: "get",
      url: process.env.REACT_APP_OIDC_API + signIn_api,
      params: params,
    });

    return result.data;
  } catch (error) {
    throw new Error(error);
  }
};

const getUserData = async (token) => {
  const getUserData_api = "/login";
  try {
    let headers = {
      Authorization: token,
    };

    const result = await axios({
      method: "get",
      url: process.env.REACT_APP_OIDC_API + getUserData_api,
      headers: headers,
    });

    return result.data;
  } catch (error) {
    throw new Error(error);
  }
};

export { oidcSignIn, getUserData };
